import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import MainLayout from './layout';
import VersionCheck from './components/VersionCheck';

class App extends Component {
    render() {
        return (
            <div className="App">
                <MainLayout/>
                <VersionCheck/>
            </div>
        );
    }
}

export default connect()(App);
